/* es5-ext/object/valid-value */ function _(require, module, exports) {
    var isValue = require(347) /* ./is-value */;
    module.exports = function (value) {
        if (!isValue(value))
            throw new TypeError("Cannot use null or undefined");
        return value;
    };
}
